import { AnyObject, CardStructureConfig, ItemAttrListDataSet, ItemIconRender } from '@mri/types';

export function cardGetIconRender(prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): ItemIconRender | undefined {
  if (typeof structure.icon === 'function')
    return structure.icon(prop);

  return undefined;
}